/**
 * Nanostores router
 */

import { createRouter } from '@nanostores/router';
import { computed } from 'nanostores';

export const $router = createRouter({
  login: '/login',
  home: '/home',
  accountreceivables:
    '/organization/:organizationId/portfolios/:portfolioId/accountreceivables',
  accountreceivable:
    '/organization/:organizationId/portfolios/:portfolioId/accountreceivables/:accountreceivableId',
  complaints: '/organization/:organizationId/complaints',
  features: '/organizations/:organizationId/features',
  experiments: '/organizations/:organizationId/experiments',
  experiment: '/organizations/:organizationId/experiments/:experimentId',
  knowlegebase:
    '/organizations/:organizationId/knowledgebases/:knowledgebaseId',
  knowledgebases: '/organizations/:organizationId/knowledgebases',
  organizations: '/organizations',
  organization: '/organizations/:organizationId',
  workspaces: '/organization/:organizationId/workspaces',
  workspace: '/organization/:organizationId/workspaces/:workspaceId',
  workspaceCollaborators:
    '/organization/:organizationId/workspace/:workspaceId/collaborators',
  projects: '/organization/:organizationId/workspace/:workspaceId/projects',
  project:
    '/organization/:organizationId/workspace/:workspaceId/projects/:projectId',
  workflows: '/organization/:organizationId/workspace/:workspaceId/workflows',
  workflow:
    '/organization/:organizationId/workspace/:workspaceId/workflows/:workflowId',
  workflows_o: '/organization/:organizationId/workflows_o',
  workflow_o: '/organization/:organizationId/workflows_o/:workflowId',
  gmail_oauth_handler: '/gmail_oauth_handler',
  outlook_oauth_handler: '/outlook_oauth_handler',
  transcriptions: '/organization/:organizationId/transcriptions',
  transcription:
    '/organization/:organizationId/transcriptions/:transcriptionId',
  portfolios: '/organization/:organizationId/portfolios',
  portfolio: '/organization/:organizationId/portfolios/:portfolioId',
  portfolioCollaborators:
    '/organization/:organizationId/portfolio/:portfolioId/collaborators',
  // flow: '/organization/:organizationId/workspace/:workspaceId/projects/workflows/:workflowId',
  smartanalyze: '/smartanalyze',
  chatbot: '/chatbot',
  settings: '/settings',
  zendesk_oauth_redirect: '/zendesk_oauth_redirect',
  aircall_oauth_redirect: '/aircall_oauth_redirect',
  quickbooks_oauth_redirect: '/quickbooks_oauth_redirect',
  stripe_oauth_redirect: '/stripe_oauth_redirect',
  whatsapp_oauth_redirect: '/whatsapp_oauth_redirect',
  indicatorscores: '/organization/:organizationId/indicatorscores',
  indicatorscore:
    '/organization/:organizationId/indicatorscores/:indicatorscoreId',
  score_logics: '/organization/:organizationId/score_logics',
  score_logic: '/organization/:organizationId/score_logics/:scorelogicId',
  workflow_execution_details:
    '/organization/:organizationId/workflows_o/:workflowId/execution_details',
  inbox: '/organization/:organizationId/inbox',
  tasks: '/organization/:organizationId/tasks',
});

export const route = computed($router, router => router?.route);
